import { jsx as t } from "react/jsx-runtime";
const o = {
  "carousel-item": "_carousel-item_10e95_32"
};
function l({ children: e, style: s }) {
  return /* @__PURE__ */ t("li", { className: o["carousel-item"], style: s, children: e });
}
export {
  l as CarouselItem
};
